

export default {
name: 'afterSalesTerms',
components: {

},
data () {
return {

}
},
methods: {

},
created () {

},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/yearNotice/script.js